module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/logo_visit-reserve-fccd406960cc3fcf3fd4c15d8c424930.png";